// Dark Mode JS Start Here

$(function () {
    const myBody = document.getElementById('mode');
    const myBtn = document.getElementById('dark-btn');  

	myBtn.addEventListener('click', () => {
        myBody.classList.toggle("mode");
    });
});

// Dark Mode JS End Here